export default class Utilities {
  public static formatDecimal = (num: number, decimals: number = 3): string => {
    return num.toFixed(decimals)
  }

  public static formatPercent = (
    num: number,
    decimals = 1,
    hideZero: string = '',
    hidePercent = false
  ): string => {
    const formattedNum = (num * 100).toFixed(decimals)
    if (hideZero.length && formattedNum === (0).toFixed(decimals))
      return hideZero
    if (isNaN(+formattedNum)) {
      return hideZero
    }
    return hidePercent ? formattedNum : `${formattedNum}%`
  }

  public static formatNumber = (num: number): string => {
    return num.toLocaleString()
  }

  public static diff = (baseNum: number, newNum: number): number => {
    return newNum - baseNum
  }

  public static formatPercentDiff = (
    baseNum: number,
    newNum: number
  ): string => {
    const difference = Utilities.diff(baseNum, newNum)
    let formatted = Utilities.formatPercent(difference)
    if (difference >= 0) {
      formatted = `+${formatted}`
    }
    return formatted
  }

  public static formatDiff = (baseNum: number, newNum: number): string => {
    const difference = Utilities.diff(baseNum, newNum)
    let formatted = Utilities.formatNumber(difference)
    if (difference >= 0) {
      formatted = `+${formatted}`
    }
    return formatted
  }

  public static classIf = (
    condition: boolean | undefined,
    ifTrue: string,
    ifFalse: string = ''
  ): string => {
    return condition ? ifTrue : ifFalse
  }

  public static boldIf = (condition: boolean | undefined): string => {
    return Utilities.classIf(condition, 'font-weight-bold')
  }
}
